<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">培训证明</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <el-form-item style="width: 120px">
              <el-input v-model="formInline.user" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item style="width: 100px">
              <el-select v-model="formInline.sex" placeholder="性别" clearable>
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formInline.card" placeholder="证件号码" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formInline.phone" placeholder="手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.special" placeholder="专业(培训证明)" clearable>
                <el-option label="质量员" value="shanghai"></el-option>
                <el-option label="安全员" value="beijing"></el-option>
                <el-option label="资料员" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formInline.company" placeholder="所属企业" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.batch" placeholder="报名批次" clearable>
                <el-option label="第一批" value="shanghai"></el-option>
                <el-option label="第二批" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="date" style="width: 400px">
              <el-date-picker
                v-model="formInline.finishTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="完成时间起"
                end-placeholder="完成时间止"
                 clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item style="width: 310px;margin-right:0">
              <el-button type="primary" size="small">搜索</el-button>
              <el-button type="success" size="small">导出搜索数据</el-button>
              <el-button type="primary" size="small" @click="batchPrint">批量打印培训证明</el-button>
            </el-form-item>
          </el-form>
          <!-- <div class="btns">
          </div>-->
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="name" label="姓名" width="80"></el-table-column>
            <el-table-column prop="province" label="性别" width="80"></el-table-column>
            <el-table-column prop="city" label="身份证号" min-width="120"></el-table-column>
            <el-table-column prop="address" label="手机号" min-width="150"></el-table-column>
            <el-table-column prop="2" label="专业(培训证明名称)" min-width="120"></el-table-column>
            <el-table-column prop="3" label="所属企业" min-width="80"></el-table-column>
            <el-table-column prop="4" label="报名批次" min-width="100"></el-table-column>
            <el-table-column prop="5" label="总学时" width="100"></el-table-column>
            <el-table-column prop="6" label="已完成学时" min-width="100"></el-table-column>
            <el-table-column prop="6" label="学习状态" width="100"></el-table-column>
            <el-table-column prop="6" label="完成时间" min-width="100"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="primary" size="small">预览培训证明</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pageSize"
            :total="totalCount"
            :page-count="totalPage"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="prevPage"
            @next-click="nextPage"
            layout="total, sizes,prev, pager, next,  jumper"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
export default {
  name: "train",
  data() {
    return {
      pageSize: 10, // 每页显示个数
      totalPage: 10, // 总页数
      totalCount: 20, // 总条目数
      currentPage: 1, // 当前页
      formInline: {
        user: "",
        sex: "",
        card: "",
        phone: "",
        special: "",
        company: "",
        batch: "",
        finishTime: ""
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        }
      ]
    };
  },
  components: {
    HeaderCom
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    // 每页数
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 上一页
    prevPage() {
      // console.log('上一页');
    },
    // 下一页
    nextPage() {
      // console.log('下一页');
    },
    // 批量打印培训证明
    batchPrint() {
      this.$confirm("确认打印培训证明吗?", "批量打印培训证明", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "打印成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table {
  max-height: 580px;
  overflow: auto;
}
.cont {
  margin-top: 30px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
  .btns {
    padding-bottom: 20px;
  }
}
</style>
